// APIサーバに登録されているメッセージID配列を取得
export const getDriverReadMessages = ($axios: any) => {
  return $axios.$get(`/drivers/me/read_messages`)
}

// APIサーバにメッセージID配列を登録
export const postDriverReadMessages = (
  $axios: any,
  read_message_id: string
) => {
  const urlParams = new URLSearchParams({
    read_message_id
  })
  return $axios.$post(`/drivers/me/read_messages`, urlParams)
}
